export default __webpack_public_path__ + "static/media/cameraConnected.87e0e849.png";